(function () {
	const multicolumnSlider = () => {
		const multicolumnSliders = Array.from(
			document.querySelectorAll(".multicolumn-slider")
		);
		if (multicolumnSliders.length === 0) return;
		multicolumnSliders.forEach((slider) => {
			const swiperEl = slider.querySelector(".swiper");
			if (swiperEl && swiperEl.classList.contains("swiper-initialized")) return;
			const sectionId = slider.dataset.id;
			const perRow = slider.dataset.perRow;
			const mobileR = slider.dataset.mobile;
			const speed = slider.dataset.speed * 1000;
			const autoplay = toBoolean(slider.dataset.autoplay);
			const enablenNavigation = toBoolean(slider.dataset.navigation);
			const stopAutoplaySlider = toBoolean(slider.dataset.stopAutoplay);
			let autoplayParm = {};

			if (autoplay) {
				// pauseOnMouseEnter is deliberately NOT used: it skips the
				// pause while a transition is running, and a delay:0 marquee
				// is always mid-transition, so it would only take effect at
				// the next slide boundary (up to `speed` seconds later).
				// Hover-pause is implemented below as an instant freeze.
				autoplayParm = {
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
				};
			}

			const multicolumnSwiper = new Swiper(`#${sectionId} .swiper`, {
				loop: true,
				longSwipesRatio: 0.1,
				slidesPerView: mobileR,
				allowTouchMove: true,
				speed: speed,
				breakpoints: {
					//576: {
					//  slidesPerView: 2,
					//},
					1100: {
						slidesPerView: +perRow + 0.4,
					},
				},
				...autoplayParm,
			});

			// "Stop autoplay on hover" for the continuous marquee: freeze the
			// wrapper at its exact current position (read from the live
			// computed transform, mid-transition) and halt autoplay. On leave,
			// finish the interrupted leg manually from the frozen spot at the
			// marquee's normal velocity, and only hand control back to
			// autoplay once the wrapper sits exactly on a slide boundary —
			// restarting autoplay mid-leg would visibly snap to the boundary,
			// because slideNext's loopFix repositions with an instant slideTo.
			if (autoplay && stopAutoplaySlider && swiperEl) {
				const wrapperEl = multicolumnSwiper.wrapperEl;
				let pendingResume = null;
				const cancelPendingResume = () => {
					if (pendingResume) {
						wrapperEl.removeEventListener("transitionend", pendingResume);
						pendingResume = null;
					}
				};

				const freeze = () => {
					cancelPendingResume();
					multicolumnSwiper.autoplay.stop();
					multicolumnSwiper.setTranslate(multicolumnSwiper.getTranslate());
					multicolumnSwiper.setTransition(0);
					// Killing the transition mid-flight fires transitioncancel,
					// not transitionend, so Swiper's `animating` flag would stay
					// true forever — and in loop mode loopPreventsSliding makes
					// every later slideNext() refuse while "animating", which
					// silently blocks any restart.
					multicolumnSwiper.animating = false;
				};

				const resume = () => {
					const sw = multicolumnSwiper;
					const target = -sw.snapGrid[sw.snapIndex];
					const remaining = Math.abs(target - sw.translate);
					if (remaining < 1) {
						sw.autoplay.start();
						return;
					}
					// Scale the duration so the finishing leg moves at the same
					// px/ms velocity as a full slide leg.
					const grid = sw.snapGrid;
					let step =
						sw.snapIndex > 0
							? Math.abs(grid[sw.snapIndex] - grid[sw.snapIndex - 1])
							: grid.length > 1
								? Math.abs(grid[1] - grid[0])
								: 0;
					if (!step) step = sw.size;
					const duration = Math.max(50, (speed * remaining) / step);
					pendingResume = (ev) => {
						if (ev.target !== wrapperEl) return;
						cancelPendingResume();
						sw.autoplay.start();
					};
					wrapperEl.addEventListener("transitionend", pendingResume);
					sw.slideTo(sw.activeIndex, duration, true, true);
				};

				// Mouse: freeze on hover, resume on hover-out.
				swiperEl.addEventListener("pointerenter", (e) => {
					if (e.pointerType !== "mouse") return;
					freeze();
				});
				swiperEl.addEventListener("pointerleave", (e) => {
					if (e.pointerType !== "mouse") return;
					resume();
				});

				// Touch: there's no hover state, so freeze/resume around the
				// drag itself — otherwise the delay:0 marquee keeps re-driving
				// its own transition through the whole gesture and the finger
				// drag never visibly moves the slider. Hooked through Swiper's
				// own touchStart/touchEnd events (not raw DOM pointerdown)
				// because Swiper's internal touch handler already binds its
				// own listeners at construction time — a DOM listener added
				// afterward fires after Swiper has read the still-animating
				// position as its drag-start reference, so the drag ends up
				// computed against a stale offset. Swiper's own events fire
				// at the correct point in its internal pipeline instead.
				multicolumnSwiper.on("touchStart", freeze);
				multicolumnSwiper.on("touchEnd", resume);
			}

			if (enablenNavigation) {
				document
					.querySelector(`#${sectionId} .multicolumn-button-next`)
					.addEventListener("click", function () {
						multicolumnSwiper.slideNext(1000);
					}, false);

				document
					.querySelector(`#${sectionId} .multicolumn-button-prev`)
					.addEventListener("click", function () {
						multicolumnSwiper.slidePrev(1000);
					}, false);

				const cursor = document.getElementById(`${sectionId}-cursor`);

				const animateCursor = (e) => {
					const x = e.clientX - cursor.offsetWidth / 2,
						y = e.clientY - cursor.offsetHeight / 2;

					const keyframes = {
						transform: `translate(${x}px, ${y}px) `,
					};

					cursor.animate(keyframes, {
						duration: 100,
						fill: "forwards",
					});
				};

				const getCursorClass = (type) => {
					switch (type) {
						case "next":
							return "cursor-icon next button button--simple";
						case "prev":
							return "cursor-icon prev button button--simple";
						default:
							return "cursor-icon button button--simple";
					}
				};

				document.querySelector(
					`#${sectionId} .multicolumn-cursor`
				).onmousemove = (e) => {
					const interactable = e.target.closest(".multicolumn__buttons"),
						interacting = interactable !== null;

					const icon = document.getElementById(`${sectionId}-cursor-icon`);

					animateCursor(e);

					cursor.dataset.type = interacting ? interactable.dataset.type : "";

					if (interacting) {
						icon.className = getCursorClass(interactable.dataset.type);
					}
				};
			}
		});
	};
	function toBoolean(string) {
		return string === "true" ? true : false;
	}

	function detectDeviceType() {
		if (isiPad()) {
			const multicolumnLists = document.querySelectorAll(".multicolumn-list");
			multicolumnLists.forEach(elem => {
				if (elem) {
					elem.classList.add("multicolumn-list__ipad");
				}
			});
		}
	}

	document.addEventListener("DOMContentLoaded", function () {
		multicolumnSlider();
		detectDeviceType();
		document.addEventListener("shopify:section:load", function () {
			multicolumnSlider();
			detectDeviceType();
		});
	});
})();
